import { render, staticRenderFns } from "./CorrectiveActionsContent.vue?vue&type=template&id=765b912e&scoped=true&"
import script from "./CorrectiveActionsContent.vue?vue&type=script&lang=js&"
export * from "./CorrectiveActionsContent.vue?vue&type=script&lang=js&"
import style0 from "./CorrectiveActionsContent.vue?vue&type=style&index=0&id=765b912e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b912e",
  null
  
)

export default component.exports